module.exports = __webpack_public_path__ + "static/media/loupsGarous_02_full.bf88aa01.jpg";